<template>
  <section v-show="fragmentsLoaded" class="eptp_content">
    <div class="container">
      <ul class="breadcrumbs">
        <li>
          <a :href="homeHref">{{ $t('pages.home.title') }}</a>
        </li>
        <li>
          <a :href="$url($t('pages.messages.url'))">{{ $t('pages.messages.title') }}</a>
        </li>
      </ul>

      <BaseGlobalAlert />

      <h1>
        {{ $t('pages.messages.title') }}
      </h1>

      <div v-if="$hasPermission(['msg_1'])" class="tabs">
        <ul>
          <li :class="{ active: activeTab === 'received' }">
            <a href="#" @click.prevent="activeTab = 'received'">{{
              $t('pages.messages.tabs.received')
            }}</a>
          </li>
          <li :class="{ active: activeTab === 'drafts' }">
            <a href="#" @click.prevent="activeTab = 'drafts'">{{
              $t('pages.messages.tabs.drafts')
            }}</a>
          </li>
          <li :class="{ active: activeTab === 'sent' }">
            <a href="#" @click.prevent="activeTab = 'sent'">{{ $t('pages.messages.tabs.sent') }}</a>
          </li>
        </ul>
      </div>

      <div class="tab-content">
        <div :class="{ 'active in': activeTab === 'received' }" class="tab-pane fade">
          <MessagesReceived :message-types="messageTypes" />
        </div>
        <div
          v-if="$hasPermission(['msg_1'])"
          :class="{ 'active in': activeTab === 'drafts' }"
          class="tab-pane fade"
        >
          <MessagesDrafts :message-types="messageTypes" />
        </div>
        <div
          v-if="$hasPermission(['msg_1'])"
          :class="{ 'active in': activeTab === 'sent' }"
          class="tab-pane fade"
        >
          <MessagesSent :message-types="messageTypes" />
        </div>
      </div>
    </div>

    <ImportantMessagesModal
      :loading="loadingImportantMessage"
      :message="displayedImportantMessage"
      @read="markImportantMessageAsRead"
    />
  </section>
</template>

<script>
import pageMixin from '../../mixins/page.mixin';
import BaseGlobalAlert from '../../components/base/BaseGlobalAlert';
import MessagesReceived from '@/components/MessagesReceived';
import MessagesDrafts from '@/components/MessagesDrafts';
import MessagesSent from '@/components/MessagesSent';
import classifierService from '@/services/classifier.service';
import { getQueryParam } from '@/util/url';

export default {
  name: 'Messages',

  components: { MessagesDrafts, MessagesSent, MessagesReceived, BaseGlobalAlert },

  mixins: [pageMixin],

  data() {
    return {
      activeTab: 'received',
      messageTypes: [],
    };
  },

  created() {
    document.title = `EPTP - ${this.$t('pages.messages.title')}`;
    if (this.$hasPermission(['msg_1'])) {
      const activeTab = getQueryParam('tab');
      if (['received', 'sent', 'drafts'].includes(activeTab)) {
        this.activeTab = activeTab;
      }
    }

    classifierService.getMessageTypes().then((res) => {
      this.messageTypes = res.data.messageType;
    });
  },

  mounted() {
    this.setupPage();
  },
};
</script>

<style>
@import '../../../assets/css/style.min.css';
@import '../../assets/index.css';
</style>
